module.exports = __webpack_public_path__ + "static/dmon-010-9801aeca1232ce72a1e9b51289e4f372.jpg";